
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import TimeRange from "../components/time-range.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetContentList,
  DelContent,
  GetSourceList,
  GetUserTem,
} from "@/request/common";
import MoreFilter from "../components/more-filter.vue";
@Component({
  components: {
    MainHeader,
    TimeRange,
    MoreFilter,
  },
})
export default class Name extends mixins(listMixin) {
  private type: any = "";
  private data: any[] = [];
  private cepings: any = [];
  private sources: any = [];
  private ifShowPrimarySearch: any = false;
  private pinggushijian: any = [
    "近7天",
    "近1个月",
    "近3个月",
    "近半年",
    "近1年",
    "自定义",
  ];
  private timeChange(e: any) {
    this.filters = JSON.parse(JSON.stringify(e));
    this.search();
  }
  private filterChange(e: any) {
    this.filters = JSON.parse(JSON.stringify(e));
    this.search();
  }
  private pinggushijianChange(e: any) {
    this.filters["测评时间"] = e;
    this.$forceUpdate();
    if (this.filters["测评时间"] !== "自定义") {
      this.search();
    }
  }
  private remoteCepings(e: any) {
    const params: any = {
      params: {
        related_type: this.type,
      },
    };
    GetUserTem(this, params).then((res: any) => {
      this.cepings = res.data[this.type];
    });
  }
  private remoteSources(e: any) {
    const params: any = {
      params: {
        search: e || "",
        limit: 9999,
      },
    };
    GetSourceList(this, params).then((res: any) => {
      this.sources = res.data;
    });
  }
  private get href() {
    return window.location.href;
  }
  private goReport(item: any) {
    // const url: any = this.href.split("/#/")[0];
    // window.open(
    //   url + "/#/main/report/ceping-report?id=" + item.id + "&&multiple=false"
    // );
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([item.id]),
      },
    });
  }
  private goRead(item: any) {
    this.$store.commit("updateIfCompose", false);
    this.$router.push({
      path: "/main/manage/edit-ceping",
      query: {
        template_id: item.template.id,
        patient_id: item.patient.id,
        content_id: item.id,
      },
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelContent(this, item.id, loading).then((data: any) => {
          this.$message.success("删除成功");
          this.getList();
        });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("jiangkangcepingFilter", JSON.stringify(this.filters));
    const params: any = {
      params: {
        page: this.filters.current_page,
        limit: 10,
        related_type: this.type,
        search: this.filters.search,
        source_id: this.filters.source?.id,
        template_id: this.filters["健康测评"]?.id,
        collect_time_filter: this.filters["测评时间"],
        collect_time_range: "",
      },
    };
    if (this.filters["测评时间"] == "自定义") {
      const start: any = this.filters.startTime || "";
      const end: any = this.filters.endTime || "";
      params.params.collect_time_range = start + "," + end;
    }
    GetContentList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.remoteCepings("");
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
    this.filters.ifPrimarySearched = false;
    if (this.$route.query.template) {
      this.filters["健康测评"] = JSON.parse(this.$route.query.template as any);
    }
    if (localStorage.getItem("jiangkangcepingFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("jiangkangcepingFilter") as any
      );
    }
    this.getList();
  }
}
